import styled from "styled-components";

export const Page = styled.main`
  background: #fffcf5;
  padding: 124px 24px 72px;
  color: #1d1d1b;
  @media (max-width: 767px) { padding: 108px 20px 40px; }
`;
export const Inner = styled.div`max-width: 1080px; margin: 0 auto;`;
export const Header = styled.header`
  max-width: 820px; margin-bottom: 32px;
  h1 { font-size: clamp(30px, 4vw, 48px); line-height: 1.14; margin: 12px 0 22px; }
  p { font-size: 18px; line-height: 1.65; margin: 0; }
  @media (max-width: 767px) { p { font-size: 16px; } }
`;
export const Eyebrow = styled.p`
  color: #1c5d27; font-size: 13px !important; font-weight: 800;
  letter-spacing: .06em; text-transform: uppercase;
`;
export const Grid = styled.div`
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px;
  @media (max-width: 900px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 620px) { grid-template-columns: 1fr; }
`;
export const GuideCard = styled.a`
  display: flex; flex-direction: column; gap: 14px; padding: 24px;
  background: white; border: 1px solid #d8ddd8; border-radius: 22px;
  color: inherit; text-decoration: none;
  svg { width: 48px; height: 48px; }
  h3 { color: #1c5d27; font-size: 21px; line-height: 1.3; margin: 0; }
  p { font-size: 15px; line-height: 1.6; margin: 0; }
  span { margin-top: auto; color: #1c5d27; font-weight: 800; padding-top: 8px; }
  &:hover { border-color: #1c5d27; }
  &:focus-visible { outline: 3px solid #ffa900; outline-offset: 4px; }
`;
export const Article = styled.article`
  max-width: 820px;
  > section { margin: 28px 0; padding: 0; }
  > section[data-box] { padding: 22px; }
  h2 { color: #1c5d27; font-size: clamp(23px, 3vw, 30px); line-height: 1.25; margin: 0 0 16px; }
  p, li { font-size: 17px; line-height: 1.75; }
  p { margin: 0 0 14px; }
  ul { padding-left: 24px; margin: 12px 0 0; }
  li + li { margin-top: 10px; }
  @media (max-width: 767px) { p, li { font-size: 16px; } }
`;
export const Answer = styled.div`
  background: white; border-left: 5px solid #ffa900; border-radius: 0 18px 18px 0; padding: 22px;
  p:last-child { margin: 0; }
`;
export const Example = styled.section.attrs({ "data-box": true })`
  padding: 24px; border-radius: 20px; background: #f1f4ef;
  p:last-child { margin-bottom: 0; }
  dl { margin: 18px 0; }
  dl > div { display:flex; justify-content:space-between; gap:16px; padding:10px 0; border-bottom:1px solid #d8ddd8; }
  dt { flex:1; } dd { margin:0; font-weight:800; white-space:nowrap; }
`;
export const Actions = styled.div`
  display: flex; flex-wrap: wrap; gap: 12px; margin-top: 20px;
`;
export const Action = styled.a`
  display: inline-flex; justify-content: center; align-items: center; min-height: 48px;
  padding: 12px 20px; border: 1px solid #1c5d27; border-radius: 28px;
  background: ${({ $primary }) => $primary ? "#ffa900" : "white"};
  border-color: ${({ $primary }) => $primary ? "#ffa900" : "#1c5d27"};
  color: ${({ $primary }) => $primary ? "#1d1d1b" : "#1c5d27"};
  text-decoration: none; font-size: 16px; font-weight: 800; line-height: 1.4;
  &:focus-visible { outline: 3px solid #1c5d27; outline-offset: 4px; }
  @media (max-width: 540px) { width: 100%; }
`;
export const ContactBox = styled.section.attrs({ "data-box": true })`
  background: white; border: 1px solid #d8ddd8; border-top: 5px solid #1c5d27;
  border-radius: 22px; padding: 24px;
`;
export const Detail = styled.details`
  border-bottom: 1px solid #d8ddd8; padding: 12px 0;
  summary { cursor: pointer; font-weight: 700; line-height: 1.5; min-height: 44px; padding: 8px 0; }
  summary:focus-visible { outline: 3px solid #ffa900; outline-offset: 2px; }
  p { margin-top: 10px; }
  a { color: #1c5d27; line-height: 1.6; display: inline-block; padding: 8px 0; }
`;
export const Back = styled.a`
  display: inline-block; padding: 10px 0; color: #1c5d27; font-weight: 700;
  margin-bottom: 20px; min-height: 44px;
`;
export const Preview = styled.section`
  padding: 64px 24px; background: #fffcf5;
  h2 { color: #1c5d27; font-size: clamp(28px, 4vw, 40px); line-height: 1.2; margin: 12px 0; }
  > div > p { max-width: 720px; line-height: 1.65; margin-bottom: 24px; }
  ${GuideCard} { padding:20px; gap:10px; svg{width:36px;height:36px} h3{font-size:19px} }
  @media (max-width: 767px) { padding: 36px 20px; ${GuideCard}{padding:18px;h3{font-size:18px}p{font-size:14px}} }
`;

export const Resources = styled.section.attrs({ "data-box": true })`background: #f1f4ef; border-radius:20px; border:1px solid #d8ddd8;`;
